<template>
  <div v-if="count" class="spb">
    <i class="el-icon-edit-outline spb-icon"></i>
    <div class="spb-text">
      <strong>{{ rejected ? "Vuelve a enviar los documentos de tu firma" : "Completa los requisitos de tu firma electrónica" }}</strong>
      <span>Necesitamos tu RUC, tu cédula y una selfie para emitirla.</span>
    </div>
    <router-link :to="{ name: 'plans.additionals.signature' }" class="spb-btn">Subir documentos</router-link>
  </div>
</template>

<script>
import signatureRequestService, { signaturesToComplete } from "../services/signatureRequestService";

/** Aviso cuando hay una firma electrónica pagada sin documentos (o rechazada). */
export default {
  name: "SignaturePendingBanner",
  data() {
    return { count: 0, rejected: false };
  },
  async mounted() {
    try {
      const { data } = await signatureRequestService.getOverview();
      const list = signaturesToComplete(data && data.data);
      this.count = list.length;
      this.rejected = list.some(t => t.rejected !== undefined);
    } catch (e) {
      this.count = 0;
    }
  }
};
</script>

<style lang="scss" scoped>
$primary: #31355c;
$accent: #3fdbbf;

.spb {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  border: 1px solid rgba($accent, 0.5);
  background: rgba($accent, 0.1);
  border-radius: 12px;
  padding: 12px 16px;
  margin: 0 15px 16px;
}
.spb-icon {
  font-size: 20px;
  color: #1fa58c;
}
.spb-text {
  flex: 1;
  min-width: 200px;
  strong {
    display: block;
    font-size: 14px;
    color: $primary;
  }
  span {
    font-size: 13px;
    color: #606266;
  }
}
.spb-btn {
  background: $primary;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  border-radius: 10px;
  padding: 9px 16px;
  white-space: nowrap;
  &:hover {
    color: #fff;
    text-decoration: none;
    opacity: 0.9;
  }
}
</style>
